import { useState } from 'react'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { EXEC_DASHBOARD_METHOD } from './execDashboardMethodCopy'

/**
 * "How this report is generated" for the Exec Sales Dashboard.
 *
 * The dashboard itself is HTML built on the server (salesDashboardService.js) and shown in an
 * iframe; this explanation sits outside it, on the page, so it does not end up in the daily
 * email. Keep it in step with backend/src/services/salesDashboardData.js and dealActivity.js.
 */

export function ExecSalesDashboardMethod() {
  const [open, setOpen] = useState(false)
  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger className="text-left">How this report is generated</CollapsibleTrigger>
      <CollapsibleContent>
        <section
          aria-label="How this report is generated"
          className="space-y-3 rounded-b-lg border border-t-0 px-4 py-3 text-sm"
        >
          {EXEC_DASHBOARD_METHOD.map((s) => (
            <div key={s.heading}>
              <h2 className="text-base font-semibold">{s.heading}</h2>
              <ul className="mt-1 list-disc space-y-1 pl-5 text-muted-foreground">
                {s.points.map((p) => (
                  <li key={p}>{p}</li>
                ))}
              </ul>
            </div>
          ))}
        </section>
      </CollapsibleContent>
    </Collapsible>
  )
}
